import type {
  AccountMergeRequestResource,
  ListAccountMergeRequestsRequest,
} from '@/features/admin/api/resources/account-merge-request'
import { type AccountMergeRequestFilterOption } from './AccountMergeRequestStore'
import {
  type AccountMergeRequestStatus,
  type AccountMergeRequestProps,
} from './AccountMergeRequest'
import { safeParseDate } from '@/utils/date-util'
import { Id } from '@/infra/id'

export function mapAccountMergeRequestResourceToProps(
  resource: AccountMergeRequestResource,
): AccountMergeRequestProps {
  return {
    id: resource.id,
    displayName: resource.display_name,
    email: resource.email,
    primaryAccountId: Id(resource.primary_id),
    duplicateAccountId: Id(resource.duplicate_id),
    picture: resource.picture ?? '',
    ticketId: resource.ticket_id,
    status: mapAccountMergeRequestStatusResourceToStatus(resource.status),
    dateCreated: safeParseDate(resource.date_created),
  }
}

function mapAccountMergeRequestStatusResourceToStatus(
  status: AccountMergeRequestResource['status'],
): AccountMergeRequestStatus {
  switch (status) {
    case 'REQUESTED':
      return 'Requested'
    case 'REJECTED':
      return 'Rejected'
    case 'LINKED':
      return 'Linked'
    case 'IGNORED':
      return 'Ignored'
  }
}

export function mapAccountMergeRequestFilterOptionToResource(
  filter: AccountMergeRequestFilterOption,
): ListAccountMergeRequestsRequest['filter'] {
  switch (filter) {
    case 'Pending':
      return 'pending'
    case 'Processed':
      return 'processed'
  }
}
